// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Zq--","productName":"Table_productName__I7qjg"};